import React from 'react'
import {useSelector} from 'react-redux'
import {OfferCTA} from 'components/Offer/Shared/OfferCTA'
import {getOfferAccessFlowSettings} from 'modules/sapiSearch/selectors'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

interface Props {
  hotelId: string
  offer: SearchOffer
  showArrowCTA?: boolean
  isSplitBooking?: boolean
  disabled?: boolean
}

export const CtaComponent = ({
  hotelId,
  offer,
  showArrowCTA = false,
  isSplitBooking,
  disabled
}: Props) => {
  const {monetisation} = useBrandCapabilities()

  const {isSpecial, isAuthLocked, isAppLocked} = useSelector(state =>
    getOfferAccessFlowSettings(state, hotelId, offer?.id)
  )

  const showLockIcon = monetisation.offersLockedByDefault && isAuthLocked
  if (showArrowCTA) {
    return (
      <Box
        data-id="ArrowIcon"
        hasMirror
        marginLeft="s200"
        color={
          isSpecial ? 'content.brand.primary' : 'content.neutral.secondary'
        }
      >
        <Icon name="ChevronRight" size="sm" />
      </Box>
    )
  }

  return (
    <Box data-id="OfferCta" whiteSpace="nowrap" marginLeft="s400">
      <OfferCTA
        showLockIcon={showLockIcon}
        isAppLocked={isAppLocked}
        offer={offer}
        hotelId={hotelId}
        isSplitBooking={isSplitBooking}
        disabled={disabled}
      />
    </Box>
  )
}
